module.exports = __webpack_public_path__ + "static/media/video.9006d421.png";